module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/2-84165e5cba580753c783bc03bf58c49a.png";